<script>
import { MESSAGE_TYPE } from 'widget/helpers/constants';
import { stripWahaSendPrefix } from 'dashboard/helper/wahaSendPrefix';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';
import { ATTACHMENT_ICONS } from 'shared/constants/messages';

export default {
  name: 'MessagePreview',
  props: {
    message: {
      type: Object,
      required: true,
    },
    showMessageType: {
      type: Boolean,
      default: true,
    },
    defaultEmptyMessage: {
      type: String,
      default: '',
    },
    // SiteUp: mostra um ícone de "entrada" quando o cliente falou por último
    // (incoming). Opt-in — só a lista de conversas usa, pra indicar de quem é a vez.
    showInboundIcon: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { getPlainText } = useMessageFormatter();
    return {
      getPlainText,
    };
  },
  computed: {
    messageByAgent() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.OUTGOING;
    },
    messageByContact() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.INCOMING;
    },
    isMessageAnActivity() {
      const { message_type: messageType } = this.message;
      return messageType === MESSAGE_TYPE.ACTIVITY;
    },
    isMessagePrivate() {
      const { private: isPrivate } = this.message;
      return isPrivate;
    },
    parsedLastMessage() {
      const { content_attributes: contentAttributes } = this.message;
      const { email: { subject } = {} } = contentAttributes || {};
      // Sem o strip, a lista mostrava "Enviado do WhatsApp tá aqui" em vez da
      // mensagem — o prefixo comia o começo do preview.
      return this.getPlainText(
        subject || stripWahaSendPrefix(this.message.content)
      );
    },
    lastMessageFileType() {
      const [{ file_type: fileType } = {}] = this.message.attachments;
      return fileType;
    },
    attachmentIcon() {
      return ATTACHMENT_ICONS[this.lastMessageFileType];
    },
    attachmentMessageContent() {
      return `CHAT_LIST.ATTACHMENTS.${this.lastMessageFileType}.CONTENT`;
    },
    isMessageSticker() {
      return this.message && this.message.content_type === 'sticker';
    },
  },
};
</script>

<template>
  <div class="overflow-hidden text-ellipsis whitespace-nowrap">
    <template v-if="showMessageType">
      <span
        v-if="isMessagePrivate"
        class="i-ri-lock-line size-4 -mt-0.5 align-middle text-n-slate-11 inline-block"
      />
      <span
        v-else-if="messageByAgent"
        class="i-ri-reply-line size-4 -mt-0.5 align-middle text-n-slate-11 inline-block"
      />
      <span
        v-else-if="showInboundIcon && messageByContact"
        class="i-ri-download-line size-4 -mt-0.5 align-middle text-n-slate-11 inline-block"
      />
      <span
        v-else-if="isMessageAnActivity"
        class="i-ri-information-line size-4 -mt-0.5 align-middle text-n-slate-11 inline-block"
      />
    </template>
    <span v-if="message.content && isMessageSticker">
      <span
        class="i-ri-image-line size-4 -mt-0.5 align-middle inline-block text-n-slate-11"
      />
      {{ $t('CHAT_LIST.ATTACHMENTS.image.CONTENT') }}
    </span>
    <span v-else-if="message.content">
      {{ parsedLastMessage }}
    </span>
    <span v-else-if="message.attachments">
      <fluent-icon
        v-if="attachmentIcon && showMessageType"
        size="16"
        class="-mt-0.5 align-middle inline-block text-n-slate-11"
        :icon="attachmentIcon"
      />
      {{ $t(`${attachmentMessageContent}`) }}
    </span>
    <span v-else>
      {{ defaultEmptyMessage || $t('CHAT_LIST.NO_CONTENT') }}
    </span>
  </div>
</template>
